import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import styles from './cards.css'
import labelPNG from './label.png'
import placeholdPNG from './placehold.png'

@withRouter
@observer(['cardTableStore'])
export default class Cards extends Component {
  handleClickTag (card) {
    const { router, examinationId, cardTableStore } = this.props

    router.push({
      pathname: `/${router.params.exam}/questions`,
      query: {
        examinationId,
        subjectId: cardTableStore.currentSubject.id,
        questionTypeId: cardTableStore.currentWay.id,
        typeId: cardTableStore.types.length ? cardTableStore.currentType.id : 0,
        tagId: card.id,
        page: 1
      }
    })
  }

  handleClickTextbook (card) {
    const { router } = this.props

    window.open(`/${router.params.exam}/practice/${card.id}/question/${card.questionIds[0]}`)
  }

  renderTagCard (card) {
    return (
      <div key={ card.id } className={ styles.card } onClick={ () => this.handleClickTag(card) }>
        <div className={ styles.image }>
          <img src={ card.img || placeholdPNG } alt={ card.name } />
        </div>
        <div className={ styles.content }>
          <div style={{ width: '70%' }}>{ card.name }</div>
          <div className={ styles.count }>{ card.count || 0 }</div>
        </div>
      </div>
    )
  }

  // TODO: some hard code need to replace
  renderTextbookCard (card) {
    return (
      <div key={ card.id } className={ styles.card } onClick={ () => this.handleClickTextbook(card) }>
        <div className={ styles.image }>
          <img src={ placeholdPNG } alt={ card.name } />
          <div className={ styles.overlay }>
            <img src={ card.imgUrl || labelPNG } role="presentation" />
            <span>{ card.name }</span>
          </div>
        </div>
        <div className={ styles.content }>
          <div>摘要填空题</div>
          <div>题型解析及示例</div>
          <div className={ styles.count }>{ card.questionIds.length }</div>
        </div>
      </div>
    )
  }

  renderCard (card) {
    return card._tag_ ? this.renderTagCard(card) : this.renderTextbookCard(card)
  }

  render () {
    const { cardTableStore } = this.props

    if (!cardTableStore.cards.length) { return null }

    return (
      <div className={ styles.root }>
        { cardTableStore.cards.map(this.renderCard.bind(this)) }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Main/Cards.js
 **/